import type { ElementType, ReactNode } from "react";
import { Menu } from "@headlessui/react";

export interface ItemProps {
  as?: ElementType;
  children: ReactNode;
  onClick?: () => void;
}

export const Item = ({ onClick, children, as }: ItemProps) => (
  <Menu.Item as={as} onClick={onClick}>
    {children}
  </Menu.Item>
);
